var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"Home"},[_c('Hero'),_c('div',{staticClass:"Home__body"},[_c('About'),_c('LatestArticles')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }